var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnfilledHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.472 10.5299C34.4867 10.3467 34.4942 10.1881 34.4976 10.0564H34.4678L34.4891 9.53592C34.494 9.41534 34.4979 9.30219 34.4979 9.19059C34.4979 4.53706 30.612 0.5 25.8334 0.5C22.3539 0.5 19.3292 2.7729 17.9531 5.69539L17.8179 5.98238H17.5007H17.4986H17.1814L17.0462 5.69539C15.6701 2.7729 12.6454 0.5 9.16584 0.5C4.38734 0.5 0.50211 4.53701 0.50211 9.19059C0.50211 9.30219 0.506004 9.41534 0.510937 9.53593L0.53223 10.0564H0.502361C0.505756 10.1881 0.513298 10.3467 0.527996 10.5299C0.577473 11.1466 0.708 12.0423 1.0343 13.1356C1.68598 15.3191 3.12227 18.3037 6.27596 21.435L6.27598 21.435L6.27968 21.4388C9.12645 24.3254 12.3075 27.0759 17.5 31.3524C22.6925 27.0759 25.8736 24.3254 28.7203 21.4388L28.7203 21.4387L28.724 21.435C31.8777 18.3037 33.314 15.3191 33.9657 13.1356C34.292 12.0423 34.4225 11.1466 34.472 10.5299Z",
    stroke: "url(#paint0_linear_13_85244)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_85244",
    x1: 8.75049,
    y1: -6.4,
    x2: 25.03,
    y2: 34.2981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D0D04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#B72316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05244"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfilledHeart);
export default __webpack_public_path__ + "static/media/unfilled-heart.8dd65d1135dd394054342f87443f9e59.svg";
export { ForwardRef as ReactComponent };